import * as React from "react";

import { type Action } from "./actions";
import {
  type ImagePanelConfig,
  type PlotPanelConfig,
  type State,
  TimeBoundsSource,
} from "./schema";

export const INITIAL_STATE: State = {
  version: "v0",
  files: [],
  datasources: [],
  panels: {},
  layout: {
    id: "root",
    axis: "x",
    relativeSize: 1,
    children: [],
  },
};

export const DEFAULT_IMAGE_PANEL_CONFIG: ImagePanelConfig = {
  rotation: 0,
  stretchToFitCanvas: true,
};

export const DEFAULT_PLOT_PANEL_CONFIG: PlotPanelConfig = {
  timeBoundsSource: TimeBoundsSource.FilesInWorkspace,
  showEvents: true,
};

export type Dispatch = React.Dispatch<Action<unknown>>;
const INITIAL_DISPATCH: Dispatch = () => {
  /** noop */
};

export const VizStateContext = React.createContext(INITIAL_STATE);
export const VizStateDispatchContext = React.createContext(INITIAL_DISPATCH);
